import styled from 'styled-components';

export const Text = styled.p`
  padding: 8px;
  text-align: center;
`;
